import "./ManageCars.css"; // Assuming you have a CSS file named ManageCars.css
import {
  fetchCars,
  setCarInactive,
  removeCar,
  activateCar,
  carAdded,
} from "./carsSlice";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

function ManageCars() {
  // ... (rest of your code)
  const dispatch = useDispatch();
  const cars = useSelector((state) => state.cars.carsList);
  const [newCarName, setNewCarName] = useState(""); // new state for car name input

  useEffect(() => {
    // Dispatch the fetchCars action when the component mounts
    dispatch(fetchCars());
  }, [dispatch]);

  const handleSetCarInactive = (carId) => {
    dispatch(setCarInactive(carId));
  };

  const handleRemoveCar = (carId) => {
    dispatch(removeCar(carId));
  };

  const handleSetCarActive = (carId) => {
    dispatch(activateCar(carId));
  };

  const handleAddCar = () => {
    if (newCarName) {
      dispatch(
        carAdded({ carName: newCarName, status: "active", capacity: 4 })
      ); // Example payload
      setNewCarName(""); // Reset input field
    }
  };

  return (
    <div className="manage-cars-container">
      <h1>Manage Cars</h1>
      <div className="add-car-form">
        <input type="text" placeholder="Car Name" className="input-field" />

        <button onClick={handleAddCar} className="add-button">
          Add Car
        </button>
      </div>
      <ul className="car-list">
        {cars.map((car) => (
          <li key={car.id} className="car-card">
            <div className="car-details">
              <span>{car.carName}</span>
              <span>{car.capacity} seats</span>
              <span>Status: {car.status}</span>
            </div>
            <div className="car-actions">
              <button
                onClick={() => handleRemoveCar(car.id)}
                className="remove-button"
              >
                Remove
              </button>
              <button
                onClick={() => handleSetCarInactive(car.id)}
                className="inactive-button"
              >
                Set Inactive
              </button>
              <button
                onClick={() => handleSetCarActive(car.id)}
                className="active-button" // You might need to add CSS for this
              >
                Set Active
              </button>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default ManageCars;
